/* eslint-disable @typescript-eslint/ban-types */
/**
 * The instance object to save the Handler functions and the relative key
 *
 * @export
 * @class HandlerInstance
 */
var HandlerInstance = /** @class */ (function () {
    /**
     * Creates an instance of HandlerInstance.
     * @param {string} name The name of the handler
     * @param {Function} value The fx handler
     * @memberof HandlerInstance
     */
    function HandlerInstance(name, value) {
        this._name = name;
        this._value = value;
    }
    Object.defineProperty(HandlerInstance.prototype, "name", {
        /**
         * Get the name value
         *
         * @readonly
         * @type {string}
         * @memberof HandlerInstance
         */
        get: function () {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HandlerInstance.prototype, "value", {
        /**
         * Get the fx value
         *
         * @readonly
         * @type {Function}
         * @memberof HandlerInstance
         */
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    return HandlerInstance;
}());
export default HandlerInstance;
//# sourceMappingURL=handler.instance.js.map